import clsx from 'clsx';
import React, { useEffect } from 'react';
import { IconXMarkSmall } from '@byted-tiktok/tux-icons';
import { useScrollLock } from '../../hooks/useScrollLock.js';
import { TUXPortal } from '../TUXPortal/TUXPortal.js';

var _ref = /*#__PURE__*/React.createElement(IconXMarkSmall, null);

var _TUXBaseDialog = function _TUXBaseDialog(props) {
  var isVisible = props.isVisible,
      hasCloseButton = props.hasCloseButton,
      closeButtonColor = props.closeButtonColor,
      onDismiss = props.onDismiss,
      getContainer = props.getContainer,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      children = props.children;

  var _useScrollLock = useScrollLock({
    defaultLock: isVisible
  }),
      lock = _useScrollLock.lock,
      unlock = _useScrollLock.unlock;

  useEffect(function () {
    isVisible ? lock() : unlock();
    return unlock;
  }, [isVisible, lock, unlock]);

  var TUXDialogClose = function TUXDialogClose() {
    return /*#__PURE__*/React.createElement("button", {
      className: "tux-base-dialog__close-button absolute p-8 text-color-TextPrimary",
      style: {
        color: closeButtonColor
      },
      onClick: onDismiss
    }, _ref);
  };

  return /*#__PURE__*/React.createElement(TUXPortal, {
    getContainer: getContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx("tux-base-dialog box-border fixed z-2000 flex items-center justify-center w-full h-full", className, isVisible ? "tux-base-dialog--open pointer-events-auto" : 'pointer-events-none')
  }, /*#__PURE__*/React.createElement("div", {
    className: "tux-base-dialog__container relative"
  }, hasCloseButton ? /*#__PURE__*/React.createElement(TUXDialogClose, null) : null, children)));
};

export { _TUXBaseDialog };
//# sourceMappingURL=_TUXBaseDialog.js.map
